/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles(() => ({
  subTitle: {
    display: 'block',
    fontSize: '1rem',
    fontWeight: 600,
    borderBottom: '1px solid #000000',
    paddingBottom: '1rem',
    marginBottom: '1rem',
  },
  userReference: {
    marginTop: '1.5rem',
    marginBottom: '2rem',
    '& span': {
      display: 'block',
    },
    '& span:first-child': {
      marginBottom: '0.5rem',
    },
    '& span:last-child': {
      fontWeight: 600,
    },
  },
}));

const ApplicationInfoDrawerSection = ({ basicFilingInfo, className }) => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <div className={className}>
      <span className={classes.subTitle}>{t('application.info')}</span>
      <p className={classes.userReference}>
        <span>{t('basic-filing.user-reference')}</span>
        <span>{basicFilingInfo?.userReference}</span>
      </p>
    </div>
  );
};

export default ApplicationInfoDrawerSection;
